/**
 * Rounds a number to a given precision. Precision expressed as a power of 10.
 * e.g. 2 -> 0.01, 1 -> 0.1, 0 -> 1, -1 -> 10, -2 -> 100, etc.
 */
export function roundTo(value: number | string, precision: number): number {
  const multiplier = Math.pow(10, precision);
  return Math.round(Number(value) * multiplier) / multiplier;
}

/**
 * Checks if two numbers are equal to a given precision. Precision expressed as a power of 10.
 * e.g. 2 -> 0.01, 1 -> 0.1, 0 -> 1, -1 -> 10, -2 -> 100, etc.
 */
export function equalToPrecision(
  valueA: number,
  valueB: number,
  precision: number,
): boolean {
  return roundTo(valueA, precision) === roundTo(valueB, precision);
}

export function dToMs(days: number): number {
  return days * 24 * 60 * 60 * 1000;
}

export function msToH(ms: number): number {
  return ms / (60 * 60 * 1000);
}

export function hToMs(h: number): number {
  return h * (60 * 60 * 1000);
}

/** Returns the Pareto frontier of the given array, sorted by the first dimension in descending order.
 * Selecting for the maximum values. Aka maxima set problem. */
export function getParetoFrontierBy<T>(
  xs: T[],
  fn: (x: T) => number,
  fn2: (x: T) => number,
): T[] {
  const byDim1Desc = [...xs].sort((a, b) => fn(b) - fn(a));
  let maxByDim2 = -Infinity;

  return byDim1Desc.filter((x) => {
    const dim2 = fn2(x);
    if (dim2 > maxByDim2) {
      maxByDim2 = dim2;
      return true;
    }
    return false;
  });
}
